import { css, Global, withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import tooltipCss from './styled-tooltip';
import 'normalize.css';

const getGlobalStyles = (theme) => css`
  html,
  body {
    height: 100%;
  }

  body,
  button,
  html,
  input,
  select,
  textarea {
    // color: var(--ds-text);

    color: ${theme.colors.primary};
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans,
      Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }

  #app {
    height: 100%;
  }

  hr {
    box-sizing: content-box;
    overflow: visible;
    background-color: rgba(9, 30, 66, 0.13);
    border: 0;
    height: 1px;
    padding: 0;
    width: 100%;
  }

  ${tooltipCss}
`;

export const LoadMoreButton = styled.div`
  position: absolute;
  display: flex;
  opacity: ${({ position }) => (position === 'bottom' ? '0' : '1')};
  bottom: 10px;
  transition: opacity 0.3s;
  width: 100%;
  justify-content: center;
`;

export const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 100px;
  max-height: 100px;
  background: rgba(9, 30, 66, 0.08);
  border-radius: 3px;
  color: #172b4d;
`;

export const ExpiredMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const GlobalStyles = ({ theme }) => <Global styles={getGlobalStyles(theme)} />;

export default withTheme(GlobalStyles);
